var _jsxFileName = "/runner/_work/smpackages/smpackages/packages/webassets/src/components/Header/anonymous/Mobile/ProductsMenu.js",
  _this = this;
import React, { useContext } from 'react';
import { List } from '@sm/wds-react';
import { SubMenuLink } from './components/SubMenuLink';
import { SeeMoreLink } from './components/SeeMoreLink';
import { surveymonkey, enterprise, integrations, audience, cx, engage, usabilla, techValidate, apply, wufoo, getFeedback, viewAllProducts, addIntegrations } from '../../config/linkInfo.js';
import SMHeaderContext from '../../SMHeaderContext';
export var ProductsMenu = function ProductsMenu() {
  var _useContext = useContext(SMHeaderContext),
    lang = _useContext.lang,
    isEUDC = _useContext.isEUDC;
  return /*#__PURE__*/React.createElement(List, {
    interactive: true,
    transparent: true,
    noRules: true,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 25,
      columnNumber: 5
    }
  }, lang === 'en' ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SubMenuLink, Object.assign({}, surveymonkey(), {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 29,
      columnNumber: 11
    }
  })), /*#__PURE__*/React.createElement(SubMenuLink, Object.assign({}, enterprise(), {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 30,
      columnNumber: 11
    }
  })), /*#__PURE__*/React.createElement(SubMenuLink, Object.assign({}, integrations(), {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 31,
      columnNumber: 11
    }
  })), !isEUDC ? /*#__PURE__*/React.createElement(SubMenuLink, Object.assign({}, audience(), {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 32,
      columnNumber: 22
    }
  })) : null, /*#__PURE__*/React.createElement(SubMenuLink, Object.assign({}, cx(), {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 33,
      columnNumber: 11
    }
  })), /*#__PURE__*/React.createElement(SubMenuLink, Object.assign({}, engage(), {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 34,
      columnNumber: 11
    }
  })), /*#__PURE__*/React.createElement(SubMenuLink, Object.assign({}, usabilla(lang), {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 35,
      columnNumber: 11
    }
  })), /*#__PURE__*/React.createElement(SubMenuLink, Object.assign({}, techValidate(), {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 36,
      columnNumber: 11
    }
  })), /*#__PURE__*/React.createElement(SubMenuLink, Object.assign({}, apply(), {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 37,
      columnNumber: 11
    }
  })), /*#__PURE__*/React.createElement(SubMenuLink, Object.assign({}, wufoo(), {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 38,
      columnNumber: 11
    }
  })), /*#__PURE__*/React.createElement(SubMenuLink, Object.assign({}, getFeedback(), {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 39,
      columnNumber: 11
    }
  }))) : lang === 'fr' ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SubMenuLink, Object.assign({}, surveymonkey(lang), {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 43,
      columnNumber: 11
    }
  })), /*#__PURE__*/React.createElement(SubMenuLink, Object.assign({}, audience(), {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 44,
      columnNumber: 11
    }
  })), /*#__PURE__*/React.createElement(SubMenuLink, Object.assign({}, apply(), {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 45,
      columnNumber: 11
    }
  })), /*#__PURE__*/React.createElement(SubMenuLink, Object.assign({}, usabilla(lang), {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 46,
      columnNumber: 11
    }
  }))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SubMenuLink, Object.assign({}, surveymonkey(), {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 50,
      columnNumber: 11
    }
  })), /*#__PURE__*/React.createElement(SubMenuLink, Object.assign({}, audience(), {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 51,
      columnNumber: 11
    }
  })), /*#__PURE__*/React.createElement(SubMenuLink, Object.assign({}, usabilla(lang), {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 52,
      columnNumber: 11
    }
  }))), /*#__PURE__*/React.createElement(SeeMoreLink, Object.assign({}, viewAllProducts(lang), {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 55,
      columnNumber: 7
    }
  })), lang !== 'en' ? /*#__PURE__*/React.createElement(SeeMoreLink, Object.assign({}, addIntegrations(), {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 56,
      columnNumber: 24
    }
  })) : null);
};
export default ProductsMenu;
//# sourceMappingURL=ProductsMenu.js.map